// Simple logger implementation for React 18 compatibility
const logger = {
  child: (options) => {
    const category = options?.category || 'app';
    return {
      debug: (message, ...args) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log(`[${category}] DEBUG:`, message, ...args);
        }
      },
      info: (message, ...args) => {
        console.log(`[${category}] INFO:`, message, ...args);
      },
      warn: (message, ...args) => {
        console.warn(`[${category}] WARN:`, message, ...args);
      },
      error: (message, ...args) => {
        console.error(`[${category}] ERROR:`, message, ...args);
      }
    };
  },
  debug: (message, ...args) => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('[app] DEBUG:', message, ...args);
    }
  },
  info: (message, ...args) => {
    console.log('[app] INFO:', message, ...args);
  },
  warn: (message, ...args) => {
    console.warn('[app] WARN:', message, ...args);
  },
  error: (message, ...args) => {
    console.error('[app] ERROR:', message, ...args);
  }
};

export default logger;